import {
	blue,
	destinationTintBlue,
	destinationTintBlueHover,
	destinationTintGold,
	destinationTintGoldHover,
	destinationTintOrange,
	destinationTintOrangeHover,
	gold,
	orange,
} from '@/theme/colors'
import { colorIndexOfDestination } from './core/destinations'

/**
 * The destination palette on the theme's tokens, indexed by
 * `destinationColorIndex`: the full colour for the selected day, the bar and
 * the map dot; the tint for a trip day's calendar fill, a step deeper under
 * the pointer.
 */
interface DestinationColor {
	fill: string
	tint: string
	tintHover: string
}

const palette: readonly DestinationColor[] = [
	{ fill: orange, tint: destinationTintOrange, tintHover: destinationTintOrangeHover },
	{ fill: blue, tint: destinationTintBlue, tintHover: destinationTintBlueHover },
	{ fill: gold, tint: destinationTintGold, tintHover: destinationTintGoldHover },
]

export const destinationColor = (colorIndex: number): DestinationColor =>
	palette[colorIndexOfDestination(colorIndex)]
